<template>
  <footer class="footer footer-theme position-relative">
    <b-container style="max-width: 1340px;">
      <div class="footer-top">
        <b-row>
          <b-col lg="2" md="6" sm="12" class="footer-column">
            <div class="footer-widget links-widget logo-widget">
              <div class="text">
                <h4>JobMATCH GmbH</h4>

                <p>
                  M7 14<br>
                  68161 Mannheim<br>
                  info@jobmatch.works<br>
                </p>
              </div>
            </div>
          </b-col>
          <b-col lg="2" md="6" sm="12" class="footer-column">
            <div class="footer-widget links-widget">
              <div class="widget-content">
                <ul class="list clearfix">
                  <li v-for="(item, index) in links1" :key="`links1-${index}`">
                    <a :href="item.link" target="_blank">
                      {{ item.text }}
                    </a>
                  </li>
                </ul>
<!--                <ul class="list clearfix">-->
<!--                  <li v-for="(item, index) in links6" :key="`links1-${index}`">-->
<!--                    <a :href="item.link" target="_blank">-->
<!--                      {{ item.text }}-->
<!--                    </a>-->
<!--                  </li>-->
<!--                </ul>-->
                <ul class="list clearfix">
                  <li v-for="(item, index) in links5" :key="`links1-${index}`">
                    <a :href="item.link" target="_blank">
                      {{ item.text }}
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </b-col>
          <b-col lg="2" md="6" sm="12" class="footer-column">
            <div class="footer-widget links-widget">
              <div class="widget-content">
                <ul class="list clearfix">
                  <li v-for="(item, index) in links2" :key="`links2-${index}`">
                    <a :href="item.link" target="_blank">
                      {{ item.text }}
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </b-col>
          <b-col lg="2" md="6" sm="12" class="footer-column">
            <div class="footer-widget links-widget">
              <div class="widget-content">
                <ul class="list clearfix">
                  <li v-for="(item, index) in links3" :key="`links3-${index}`">
                    <a :href="item.link" target="_blank">
                      {{ item.text }}
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </b-col>
          <b-col lg="2" md="6" sm="12" class="footer-column">
            <div class="footer-widget links-widget">
              <div class="widget-content">
                <ul class="list clearfix">
                  <li v-for="(item, index) in links4" :key="`links4-${index}`">
                    <a :href="item.link" target="_blank">
                      {{ item.text }}
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </b-col>
          <b-col lg="2" md="6" sm="12" class="footer-column">
            <div class="footer-widget links-widget">
              <div class="widget-content">
                <ul class="list clearfix">
                  <li v-for="(item, index) in links7" :key="`links5-${index}`">
                    <a :href="item.link" target="_blank">
                      {{ item.text }}
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </b-col>
        </b-row>
      </div>
      <div class="footer-bottom">
        <b-row>
          <b-col>
            <div class="clearfix">
              <div class="copyright d-flex justify-content-between">
                <p>
                  © {{ new Date().getFullYear() }} JobMATCH GmbH
                </p>

                <p>
                  <a target="_blank" :href="`https://jobmatch.works/${lang}/Kontakt/form.php`">Kontakt</a> · <a target="_blank" :href="`https://jobmatch.works/${lang}/Kontakt/impressum.php`">Impressum</a>
                </p>
              </div>
            </div>
          </b-col>
        </b-row>
      </div>
    </b-container>
  </footer>
</template>

<script lang="ts">
import { AppModule } from '@/store/modules/app';
import { Component, Vue } from 'vue-property-decorator';

interface LinkItem {
  text: string
  link?: string
  hasIcon?: boolean
}

@Component
export default class FooterComponent extends Vue {
  get translations() {
    return AppModule.translation;
  }

  get lang() {
    return 'de'; // AppModule.language;
  }

  get links1() {
    const resultArr: LinkItem[] = [
      {
        text: 'Willkommen',
        link: `https://jobmatch.works/${this.lang}/index.php`,
      },
    ];
    return resultArr;
  }

  get links2() {
    const resultArr: LinkItem[] = [
      {
        text: 'Digitale Lösungen', // 'Plattformen',
        link: `https://jobmatch.works/${this.lang}/Plattformen/index.php`,
      },
      {
        text: 'Bedarfe und Herausforderungen',
        link: `https://jobmatch.works/${this.lang}/Plattformen/index.php`,
      },
      {
        text: 'Lösungskomponenten - Job Talent Space und TALENTRO',
        link: `https://jobmatch.works/${this.lang}/Plattformen/loesungsansatz.php`,
      },
    ];
    return resultArr;
  }

  get links3() {
    const resultArr: LinkItem[] = [
      {
        text: 'Arbeitgeberservice', // 'Projektunterstützung',
        link: `https://jobmatch.works/${this.lang}/Arbeitgeberservice/index.php`,
      },
      // {
      //   text: 'Deutschtraining',
      //   link: `https://jobmatch.works/${this.lang}/Projektsupport/deutschtraining.php`,
      // },
      // {
      //   text: 'Angebote zur Projektunterstützung',
      //   link: `https://jobmatch.works/${this.lang}/Projektsupport/index.php`,
      // },
      // {
      //   text: 'Integrationscoaching',
      //   link: `https://jobmatch.works/${this.lang}/Projektsupport/integrationscoaching.php`,
      // },
    ];
    return resultArr;
  }

  get links4() {
    const resultArr: LinkItem[] = [
      {
        text: 'Deutschtraining', // 'DaF/DaZ',
        link: `https://jobmatch.works/${this.lang}/Deutschtraining/index.php`,
      },
      {
        text: 'Deutschlernplattform',
        link: `https://jobmatch.works/${this.lang}/Deutschtraining/Deutschlernplattform.php`,
      },
      {
        text: 'Deutschlehrkräfte',
        link: `https://jobmatch.works/${this.lang}/Deutschtraining/Deutschlehrkraefte.php`,
      },
      {
        text: 'Deutschlerninhalte',
        link: `https://jobmatch.works/${this.lang}/Deutschtraining/Deutschlerninhalte.php`,
      },
      {
        text: 'Deutschprüfungen',
        link: `https://jobmatch.works/${this.lang}/Deutschtraining/Deutschpruefungen.php`,
      },
    ];
    return resultArr;
  }

  get links5() {
    const resultArr: LinkItem[] = [
      {
        text: this.translations[14997],
        link: '/',
      },
      {
        text: this.translations[15401],
        link: `https://jobmatch.works/${this.lang}/Job-Talent-Space/Auf-einen-Blick.php`,
      },
      {
        text: 'FAQ',
        link: `https://jobmatch.works/${this.lang}/Job-Talent-Space/FAQ.php`,
      },
    ];
    return resultArr;
  }

  get links6() {
    const resultArr: LinkItem[] = [
      {
        text: 'Über uns',
        link: `https://jobmatch.works/${this.lang}/Ueber-uns/index.php`,
      },
    ];
    return resultArr;
  }

  get links7() {
    const resultArr: LinkItem[] = [
      {
        text: 'Kontakt',
        link: `https://jobmatch.works/${this.lang}/Kontakt/index.php`,
      },
      {
        text: 'So erreichen Sie uns',
        link: `https://jobmatch.works/${this.lang}/Kontakt/index.php`,
      },
      {
        text: 'Impressum',
        link: `https://jobmatch.works/${this.lang}/Kontakt/impressum.php`,
      },
      {
        text: 'Kontaktformular',
        link: `https://jobmatch.works/${this.lang}/Kontakt/form.php`,
      },
      {
        text: 'Datenschutz',
        link: `https://jobmatch.works/${this.lang}/Kontakt/Datenschutz.php`,
      },
    ];
    return resultArr;
  }
}
</script>
<style lang="scss" scoped>
[theme="default"] {
  .footer-theme {
    background: #69726A;
    padding: 2.35rem 0 0;
    .pull-left {
      float: left;
    }
    .pull-right {
      float: right;
    }
    a {
      text-decoration: none;
      transition: all 500ms ease;
      -moz-transition: all 500ms ease;
      -webkit-transition: all 500ms ease;
      -ms-transition: all 500ms ease;
      -o-transition: all 500ms ease;
    }
    ul {
      padding: 0;
    }
    h4 {
      color: #ffffff;
      font-size: 20px;
    }
    .footer-top {
      position: relative;
      display: block;
      padding: 0px 0px 50px 0px;
      border-bottom: 1px solid rgba(255, 255, 255, 0.1);
      p {
        color: #ffffff;
        font-size: 18px;
        line-height: 26px;
        margin-bottom: 26px;
      }
      .widget-content li {
        a {
          position: relative;
          display: inline-block;
          font-size: 18px;
          line-height: 26px;
          font-weight: 600;
          color: #ffffff;

          &:hover {
            color: var(--portal-primary);
          }
        }
      }
      .footer-column:nth-child(2) .links-widget {
        margin-left: 0px;
      }
    }
    .footer-bottom {
      position: relative;
      padding-top: 15px;
      .copyright p {
        color: #ffffff;
        line-height: 26px;
        font-size: 16px;
        a {
          display: inline-block;
          color: #ffffff;
          //text-transform: uppercase;
          &:hover {
            color:  var(--portal-primary);
          }
        }
      }
      .footer-nav li {
        position: relative;
        display: inline-block;
        margin-right: 20px;
        &:last-child {
          margin-right: 0px;
          &:before {
            display: none;
          }
        }
        a {
          position: relative;
          display: inline-block;
          font-size: 16px;
          line-height: 26px;
          font-weight: 300;
          color: #ffffff;
          &:hover {
            color: var(--portal-primary);
          }
        }
        &:before {
          position: absolute;
          content: '.';
          color: #ffffff;
          width: 2px;
          height: 16px;
          top: -3px;
          right: -12px;
        }
      }
    }
  }
}
</style>
